// @ts-nocheck
import { IndustryHighlight } from '@core/config/industryHighlights';

import styles from './CareerPaths.module.css';

type CareerPathsProps = {
  industryData: IndustryHighlight; // Replace 'any' with the actual type if available
  hideTitle?: boolean;
};

const CareerPaths = ({ industryData, hideTitle }: CareerPathsProps) => {
  if (!industryData || !industryData.careerPaths || industryData.careerPaths.length === 0) {
    console.error('No career paths data available for the selected industry.');
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        {!hideTitle && <h2 className={styles.title}>{industryData.name} Industry Highlights</h2>}
      </div>

      <div className={styles.careerPathsSection}>
        <h4 className={styles.subtitle}>Trending Career Paths</h4>
        <p className={styles.sectionDescription}>
          This list considers factors such as job growth, salary potential, and demand in the job market:
        </p>

        <ul className={styles.pathsList}>
          {industryData.careerPaths.map((path, index) => (
            <li key={index} className={styles.pathItem}>
              <div className={styles.pathBullet} />
              <span className={styles.pathText}>{path}</span>
            </li>
          ))}
        </ul>
      </div>

      {industryData.careerPathsLinks && (
        <div className={styles.sourceWrapper}>
          <span className={styles.sourceLabel}>{industryData.careerPathsLinks.label} </span>
          {industryData.careerPathsLinks.links.map((link, index) => (
            <span key={index}>
              <a href={link.link} className={styles.sourceLink} target="_blank" rel="noopener noreferrer">
                {link.linkText}
              </a>
              {link.connectingText && index < industryData.careerPathsLinks.links.length - 1 && (
                <span className={styles.connectingText} dangerouslySetInnerHTML={{ __html: link.connectingText }} />
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default CareerPaths;
